// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appDisableRightAndLongpress]',
  standalone: false
})
export class DisableRightAndLongpressDirective {
  private touchTimeout: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.disableDragAndSelect();
  }

  // Prevent right click
  @HostListener('contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    event.preventDefault();
  }

  // Prevent long press on touch devices
  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    this.touchTimeout = setTimeout(() => {
      event.preventDefault();
    }, 500);
  }

  @HostListener('touchend')
  onTouchEnd() {
    clearTimeout(this.touchTimeout);
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    this.touchTimeout = setTimeout(() => {
      event.preventDefault();
    }, 500);
  }

  @HostListener('mouseup')
  onMouseUp() {
    clearTimeout(this.touchTimeout);
  }

  private disableDragAndSelect() {
    this.renderer.setAttribute(this.el.nativeElement, 'draggable', 'false');
    this.renderer.setStyle(this.el.nativeElement, 'user-select', 'none');
    this.renderer.setStyle(this.el.nativeElement, '-webkit-user-drag', 'none');
    this.renderer.setStyle(this.el.nativeElement, '-webkit-touch-callout', 'none'); // disables long tap popup on iOS/Safari
  }
}